import { pct } from "./format";

/**
 * Extract a numeric week index from strings like "Semana 3 - Março".
 * Returns null when not found.
 */
export const parseWeekNumber = (s) => {
  if (!s) return null;
  const m = String(s).match(/semana\s*0*(\d+)/i);
  return m ? parseInt(m[1], 10) : null;
};

/**
 * Determine the "current" week number:
 * - If there are cadastros, use the max week number seen (assume vendedora is on it).
 * - Otherwise, use the current ISO week of the month as a fallback (1..5).
 */
export const currentWeekNumber = (condominios = []) => {
  const nums = condominios
    .map((c) => parseWeekNumber(c.semana_planejada))
    .filter((n) => Number.isFinite(n));
  if (nums.length) return Math.max(...nums);
  const now = new Date();
  const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const day = now.getDate() + firstOfMonth.getDay();
  return Math.ceil(day / 7);
};

/**
 * Returns condominios that:
 *  - have a meta > 0
 *  - are below 50% (vendas/meta)
 *  - are planned for the current week OR earlier (i.e., risk / overdue)
 */
export const condominiosEmAlerta = (condominios = []) => {
  const currentWeek = currentWeekNumber(condominios);
  return condominios
    .filter((c) => {
      const meta = Number(c.meta_vendas || 0);
      if (meta <= 0) return false;
      const p = pct(c.vendas_realizadas, meta);
      if (p >= 50) return false;
      const wk = parseWeekNumber(c.semana_planejada);
      if (wk === null) return true; // sem semana definida: também é alerta
      return wk <= currentWeek;
    })
    .map((c) => ({ ...c, _percent: pct(c.vendas_realizadas, c.meta_vendas) }))
    .sort((a, b) => a._percent - b._percent);
};
